import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate, Navigate } from 'react-router-dom'
import AppLogo from '../../components/AppLogo'
import { getMe, logout } from '../../store/authSlice'
import { RootState, AppDispatch } from '../../store/store'
import { shellConsumerLoginUrl } from '../../utils/shellConsumerLoginUrl'
import { isFoodExpiredSession } from '../../utils/foodExpiredSession'
import { isFoodPendingSession } from '../../utils/foodPendingSession'
import FoodPaymentKey from '../../components/FoodPaymentKey'

export default function PlanVencidoPage() {
  const location = useLocation()
  const navigate = useNavigate()
  const dispatch = useDispatch<AppDispatch>()
  const { user, subscription, accessToken, meReady } = useSelector((s: RootState) => s.auth)
  const email = (location.state as any)?.email || user?.email || ''
  const [renewUrl, setRenewUrl] = useState<string>(
    String((user as any)?.renewUrl || (user as any)?.renew_url || ''),
  )

  useEffect(() => {
    if (!accessToken) return
    dispatch(getMe()).then((res: any) => {
      const payload = res?.payload
      const url = payload?.renewUrl || payload?.renew_url || payload?.user?.renewUrl
      if (url) setRenewUrl(String(url))
    })
  }, [accessToken, dispatch])

  const handleRenew = () => {
    const dest = renewUrl || shellConsumerLoginUrl()
    window.location.assign(dest)
  }

  const handleLogout = () => {
    dispatch(logout())
    try {
      localStorage.removeItem('d28d_shell')
      localStorage.removeItem('d28d_token')
    } catch { /* noop */ }
    navigate('/login')
  }

  const expired = isFoodExpiredSession(user, subscription) || Boolean((user as any)?.planExpired)

  if (accessToken && meReady && isFoodPendingSession(user, subscription)) {
    return <Navigate to="/pendiente-activacion" replace />
  }
  if (accessToken && meReady && !expired) {
    return <Navigate to="/dashboard" replace />
  }

  return (
    <div className="min-h-screen bg-[#f9fafb] flex items-center justify-center p-4">
      <div className="bg-white rounded-3xl shadow-lg border border-gray-100 p-8 max-w-md w-full text-center">
        <div className="flex justify-center mb-6">
          <div className="w-16 h-16 rounded-2xl bg-[#64ba30]/10 flex items-center justify-center">
            <AppLogo size={40} />
          </div>
        </div>
        <p className="text-xs font-semibold tracking-wide uppercase text-[#64ba30] mb-2">Food Plan</p>
        <h1 className="text-2xl font-bold text-[#111827] mb-3">Tu plan ha vencido</h1>
        <p className="text-gray-600 text-sm leading-relaxed mb-6">
          {email ? <span className="font-medium text-[#111827]">{email}. </span> : null}
          Tu suscripción Food Plan ya no está vigente. Las funciones de nutrición, medidas y recetas quedan bloqueadas hasta que renueves. Puedes pagar con Wompi o por la misma llave.
        </p>
        <FoodPaymentKey />
        <button
          type="button"
          onClick={handleRenew}
          className="w-full py-3.5 rounded-2xl text-white text-base font-semibold bg-[#64ba30] hover:bg-[#58a52a] transition-colors mb-3"
        >
          Renovar con Wompi
        </button>
        {accessToken && expired ? (
          <button
            type="button"
            onClick={handleLogout}
            className="text-sm text-gray-500 hover:text-gray-700 transition-colors"
          >
            Cerrar sesión
          </button>
        ) : (
          <button
            type="button"
            onClick={() => navigate('/login')}
            className="text-sm text-gray-500 hover:text-gray-700 transition-colors"
          >
            ← Volver al inicio de sesión
          </button>
        )}
      </div>
    </div>
  )
}
